// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"styles-f1550c47":"9e124816","styles-e96e9bea":"fe611d48"}[chunkId] + ".css";
};